import React from "react";
import { Suspense, lazy } from 'react';
import Swal from 'sweetalert2'
import SkeletonL from "../Components/Skeleton/Withlogin";

const InstallmentTracker = lazy(() => import('../Components/Dashboard/InstallmentTracker/InstallmentTracker'));

const AuthInstallmentTracker = () => {
   const useAuth = () => {
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? (
    <Suspense fallback={<SkeletonL/>}>
      <InstallmentTracker/>
    </Suspense>
  ) : (
    <>
      {Swal.fire({
        title: "Timeout",
        text: "Your Session has been expired please relogin",
        icon: "info",
        confirmButtonText: "Ok"
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href="https://accredian.com"
        }
      })}
    </>
  )
}

export default AuthInstallmentTracker;
